import { useMemo } from 'react';
/**
 * 初回固定結果のuseMemoの結果を返却する
 * @param callback
 * @returns {unknown}
 */
export const useMemoFrozen = (callback) => 
// eslint-disable-next-line react-hooks/exhaustive-deps
useMemo(callback, []);
